<template>
  <section class="detail-card">
    <button class="detail-card__header" type="button" v-on:click="isOpen = !isOpen">
      <div class="detail-card__title">
        <span>{{ title }}</span>
        <i class="fas fa-chevron-down" v-if="!isOpen"></i>
        <i class="fas fa-chevron-up" v-else-if="isOpen"></i>
      </div>
      <div class="detail-card__count">
        {{ $filters.localize("main.countTitle") }}: {{ this.rows.length }}
      </div>
    </button>
    <div class="detail-card__body" v-if="isOpen">
      <slot
        v-if="entity"
        :entity="entity"
        :save="save"
        :add="addRow"
        :rows="rows"
        :loadRows="loadRows"
      ></slot>
      <div class="detail-table-wrap">
        <table class="table table-sm table-hover sortable detail-table">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header of headers"
                v-bind:key="header.field"
              >
                <p class="d-inline">{{ localizeColumn(header) }}</p>
                <fas-sort
                  class="d-inline"
                  v-if="header.sort"
                  @click="sort(header.field)"
                  v-bind:currentSort="currentSort"
                  v-bind:currentSortDir="currentSortDir"
                  v-bind:field="header.field"
                />
              </th>
            </tr>
          </thead>
          <tbody v-if="rowsData.length > 0">
            <tr v-for="row of rowsData" v-bind:key="row.id">
              <td
                class="text-center vertical-center"
                v-bind:class="header.class ? header.class : ''"
                v-for="header of headers"
                v-bind:key="header.field + row.id"
                v-on:click.prevent="
                  router(getRowValue(row, header.router), header.router?.name)
                "
              >
                <button
                  v-if="header.action"
                  type="button"
                  class="btn btn-sm btn-danger detail-action"
                  v-on:click="remove(row.id)"
                >
                  X
                </button>
                <input
                  :id="row.id"
                  @blur="save(this.rowsData.filter((x) => x.id === row.id)[0])"
                  class="form-control text-center vertical-center detail-control"
                  v-else-if="header.input && header.input.type != 'checkbox'"
                  :type="header.input.type"
                  :disabled="!header.enabeled"
                  v-model="row[header.field]"
                />

                <input
                  :id="row.id"
                  @click.stop
                  @change="save(this.rowsData.filter((x) => x.id === row.id)[0])"
                  class="text-center vertical-center detail-checkbox"
                  v-else-if="header.input && header.input.type == 'checkbox'"
                  :type="header.input.type"
                  :disabled="!header.enabeled"
                  :true-value="true"
                  :false-value="false"
                  v-model="row[header.field]"
                />

                <select
                  :id="row.id"
                  @blur="save(this.rowsData.filter((x) => x.id === row.id)[0])"
                  v-else-if="header.lookup"
                  :disabled="!header.enabeled"
                  class="form-control vertical-center detail-control"
                  v-model="row[header.field]"
                >
                  <option
                    v-for="option in lookups[header.lookup]"
                    v-bind:key="option.id"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>

                <img
                  v-else-if="header.image"
                  v-bind:src="
                    getRowValue(row, header) ??
                    require('@/assets/not-pictured-large.png')
                  "
                />

                <p :id="row.id" class="detail-value" v-else>{{ formatCellValue(row, header) }}</p>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isRowsLoading">
            <tr>
              <td :colspan="headers.length" class="detail-empty">
                Завантаження...
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="headers.length" class="detail-empty">
                {{ $filters.localize("main.notdata") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import FasSort from "@/components/Sections/FasSort.vue";
import tabledetail from "@/mixins/tabledetail.js";
export default {
  name: "BaseDetail",
  mixins: [tabledetail],
  emits: ["on-parrent-load", "main-save"],
  components: {
    FasSort,
  },
  computed: {
    isOpen: {
      get() {
        if (this.disableOpenClose) return this.disableOpenClose;
        return this.baseIsOpen;
      },
      set(value) {
        this.baseIsOpen = value;
      },
    },
  },
  data() {
    return {
      baseIsOpen: true,
      isRowsLoading: false,
      rowsLoadTimeout: null,
      rowsLoadRequestId: 0,
      rowsAbortController: null,
    };
  },
  watch: {
    rootId: {
      handler(value) {
        if (!value) {
          this.rows = [];
          this.cancelRowsLoad();
          return;
        }

        this.scheduleLoadRows();
      },
      immediate: true,
    },
  },
  props: {
    title: String,
    entity: Object,
    lookups: Object,
    headers: { type: Array, require: true },
    rootId: { type: String, require: true },
    rootColumn: { type: String, require: true },
    removeButton: Boolean,
    disableOpenClose: Boolean,
    beforeSave: Function,
  },
  methods: {
    reload() {
      this.$emit("on-parrent-load");
    },
    addRow(row) {
      this.rows.unshift(row);
      this.reload();
    },
    remove(id) {
      this.$store
        .dispatch("remove", { table: this.schemaName, body: { id: id } })
        .then(() => {
          this.$toast.success("Успішно видалено");
          this.rows = this.rows.filter((x) => x.id !== id);
          this.reload();
        })
        .catch((error) => this.$toast.error(error.response.data.message));
    },
    formatCellValue(row, header) {
      const value = this.getRowValue(row, header);
      return header.format ? header.format(value, row) : value;
    },
    async save(data) {
      try {
        if (this.beforeSave) {
          await this.beforeSave(data);
        }

        const result = await this.$store.dispatch(data.id ? "update" : "add", {
          table: this.schemaName,
          body: this.getRequest(data),
        });

        if (!data.id) {
          this.rows.unshift(result.data.data);
        }

        this.$toast.success("Успішно збережено");
        this.reload();
      } catch (error) {
        this.$toast.error(error.response.data.message);
        throw error;
      }
    },
    getRequest(data) {
      let keys = Object.keys(data)
        .filter((x) => x.includes("Id"))
        .map((x) => x.replace("Id", ""));
      let obj = data;
      keys.forEach((x) => (obj[x] = null));
      return JSON.parse(JSON.stringify(obj));
    },
    scheduleLoadRows() {
      window.clearTimeout(this.rowsLoadTimeout);
      this.rowsLoadTimeout = window.setTimeout(() => {
        this.loadRows();
      }, 0);
    },
    loadRows() {
      if (!this.rootId) {
        this.rows = [];
        return Promise.resolve();
      }

      this.cancelRowsLoad();
      const requestId = ++this.rowsLoadRequestId;
      const controller = new AbortController();
      this.rowsAbortController = controller;
      this.isRowsLoading = true;

      return this.$store
        .dispatch("getFilter", {
          table: this.schemaName,
          body: { id: this.rootId, rootColumn: this.rootColumn },
          signal: controller.signal,
        })
        .then((response) => {
          if (requestId === this.rowsLoadRequestId) {
            this.rows = response.data.data;
          }
        })
        .catch((error) => {
          if (error.code !== "ERR_CANCELED") {
            throw error;
          }
        })
        .finally(() => {
          if (requestId === this.rowsLoadRequestId) {
            this.isRowsLoading = false;
            this.rowsAbortController = null;
          }
        });
    },
    cancelRowsLoad() {
      if (this.rowsAbortController) {
        this.rowsAbortController.abort();
        this.rowsAbortController = null;
      }
      this.isRowsLoading = false;
    },
  },
  mounted() {
    this.isNotPages = true;
  },
  beforeUnmount() {
    window.clearTimeout(this.rowsLoadTimeout);
    this.cancelRowsLoad();
  },
};
</script>

